/**
 * Created by frank.law on 11/14/17.
 */
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import HelpContainer from './HelpContainer'
import LoginContainer from './LoginContainer';

class Main extends React.Component {

    render() {
        return (
            <Switch>
                <Route exact path={`*${process.env.REACT_APP_LOGIN_HELP_ENDPOINT}`} component={HelpContainer}/>
                <Route exact path={`*${process.env.REACT_APP_RESET_PASSWORD_ENDPOINT}`} render={(props)=><LoginContainer resetPassword={true} {...props} />}/>
                <Route exact path={`*${process.env.REACT_APP_STANDARD_LOGIN_REQUEST_ENDPOINT}`} render={(props)=><LoginContainer standardLoginRequest={true} {...props} />}/>
                <Route exact path={`*${process.env.REACT_APP_STANDARD_LOGIN_REDIRECT_ENDPOINT}`} render={(props)=><LoginContainer standardLoginRedirect={true} {...props} />}/>
                <Route exact path={`*${process.env.REACT_APP_SAML_ACS_ERROR_ENDPOINT}`}  render={(props)=><LoginContainer displayError={true} {...props} />}/>
                <Route exact path={`*${process.env.REACT_APP_SAML_SLO_ERROR_ENDPOINT}`}  render={(props)=><LoginContainer displayError={true} {...props} />}/>
                <Route exact path='*' component={LoginContainer}/>
            </Switch>
        );
    }
}

export default Main;
